import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import './deleteOrderModal.less';
import { Button } from '@material-ui/core';

class OrderStatusModal extends React.Component {
  onOk = () => {
    const { onOk, orderId, closeModal } = this.props;
    onOk(orderId);
    closeModal();
  }

  render() {
    const { open, orderId, closeModal } = this.props;

    // prevent of duplicate modal render (material ui bug)
    if (document.querySelectorAll('.delete-order-modal').length) {
      return null;
    }

    return (
      <Dialog onClose={this.onClose} open={open} className="delete-order-modal">
        <DialogTitle id="simple-dialog-title">
          Usuwanie zamówienia
        </DialogTitle>

        <div className="delete-order-modal__content">
          Czy na pewno chcesz usunąć zamówienie o id:
          {' '}
          {orderId}
          ?

          <div className="delete-order-modal__buttons-container">
            <Button onClick={this.onOk}>
              Tak
            </Button>
            <Button variant="contained" color="primary" onClick={closeModal}>
              Nie
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}

OrderStatusModal.propTypes = {
  onOk: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  orderId: PropTypes.string.isRequired,
};

export default OrderStatusModal;
